import React,{useState} from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Grid
} from "@mui/material";
import { toPascalCase } from "../../../utils/formatting";
import ModelViewForMobile from "../../ui/ModelViewForMobile";
interface FundRequestCardProps {
  data: any;
}

export default function FundRequestCard({ data }: FundRequestCardProps) {
    
  const [openModal,setOpenModal]=useState<boolean>(false);
  const handleCloseModal = (type:boolean) => {
    setOpenModal(type);
  };
  const handleViewStatusModal = () => {
    setOpenModal(true);
  };
  return (
    <>
        <Card
        sx={{
            width: "100%",
            maxWidth: 360,
            mx: "auto",
            borderRadius: 3,
            boxShadow: 3,
            backgroundColor: "#f9f9f9",
            mt: 3,
        }}
        >
        <CardContent>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={9}>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">
                            Request ID
                        </Typography>
                        <Typography fontWeight={600}>
                            {data?.referenceNumber}
                        </Typography>
                        </Grid>

                        <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">
                            Disbursement Amount
                        </Typography>
                        <Typography fontWeight={600}>
                            {data?.disbursedAmount}
                        </Typography>
                        </Grid>

                        <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">
                            Disbursement Type
                        </Typography>
                        <Typography fontWeight={600}>
                            {data &&
                            data?.lienValues &&
                            data?.lienValues
                                .map((item: any) => `${toPascalCase(item.type)}`)
                                .join(" + ")}
                        </Typography>
                        </Grid>
                    </Grid>
                    {/* View details */}
                    <Box mt={1}>
                    <Button variant="text" size="small" onClick={() => handleViewStatusModal()}>
                        View details →
                    </Button>
                    </Box>
                </Grid>
            </Grid>
        </CardContent>
        </Card>
        <ModelViewForMobile rows={data} onCloseFun={() => handleCloseModal(false)} openModal={openModal}/>
    </>
  );
}
